export enum PaymentAuthorizationResponseStatus {
  HARD_DECLINE='HARD_DECLINE',
   SOFT_DECLINE = 'SOFT_DECLINE',
   APPROVED = 'APPROVED',
   PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
}
